module.exports = __webpack_public_path__ + "4b3cc1ad8ede64df1505d35b458a0680.pdf";